import React from "react";
import SampleImage from "../../assets/images/logo.png"
import { Link } from "react-router-dom";



function Card({ title,location, engin, negotiable, model, MainImage,fuelType }) {
  return (
    <div className="pt-4">
      <Link to="/relateddetails">
      <div className="lg:w-[242px] lg:h-[375px] md:w-[200px] md:h-[375px] w-[170px] h-[375px] bg-white rounded-lg shadow-xl overflow-hidden hover:bg-gray-100 cursor-pointer transition-all">
        <div className="lg:w-[242px] lg:h-[150px] md:w-[200px] md:h-[130px] ">
          <img
            src={MainImage || SampleImage }
            alt={title}
            className="object-cover "
          />
        </div>
        <div className="p-5">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">{title}</h2>
          <p className="text-md text-gray-600 pt-2">Address : {location}</p>
          <p className="text-gray-600">Model : {model}</p>
          <p className="text-gray-600 ">Engine: {engin}</p>
          <p className="text-gray-600  mb-2">Fuel: {fuelType}</p>
          <p className=" text-primary">{negotiable ? "Negotiable" : ""}</p>
        </div>
      </div>
      </Link>
    </div>
  );
}

export default Card;
